import {
  REFERRAL_LOADING,
  REFERRAL_ACTIVE_LOADED,
  REFERRAL_STATS_LOADED,
  REFERRAL_ERROR
} from '../actions/types';

const initialState = {
  activeCode: null,
  programId: null,
  pathwayId: null,
  stats: { shared: 0, used: 0, referredUsers: [] },
  loading: false
};

export default function referralReducer(state = initialState, action) {
  switch (action.type) {
    case REFERRAL_LOADING:
      return { ...state, loading: true };
    case REFERRAL_ACTIVE_LOADED:
      return {
        ...state,
        activeCode: action.payload.code,
        programId: action.payload.programId,
        pathwayId: action.payload.pathwayId || null,
        loading: false
      };
    case REFERRAL_STATS_LOADED:
      return {
        ...state,
        stats: action.payload
      };
    case REFERRAL_ERROR:
      return { ...state, loading: false };
    default:
      return state;
  }
}
